
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import Signup from "./pages/SignupPage";
import OtpVerify from "./pages/OtpPage";
import Verify from "./components/Verify";
import LanguageState from "./context/language/LanguageState";
import Profile from "./pages/ProfilePage";
import QuestionPage from "./pages/QuestionPage";
import ChatHistory from "./components/chathistory";
import SessionTimeoutPopup from "./components/Session";
import Alert from "./components/Alert";
import ViewAppointments from "./components/ViewAppointments";
import ViewLabTests from "./components/ViewLabTests";
import ViewReminders from "./components/ViewReminders";
import LabProfile from "./components/LabProfile";
import ViewReminderReport from "./components/ViewReminderReport"
import MedicineChatbot from "./components/MedicineChatbot";
import PatientSummaryNote from "./components/PatientSummaryNote ";
import PrescriptionForm from "./components/PrescriptionForm"
import ChemistOrderDashboard from "./components/ChemistOrderDashboard";
function App() {
  return (
    <div className="App" >
      <BrowserRouter>
      <LanguageState>
        <Alert/>
        <SessionTimeoutPopup/>
        <Routes>
          <Route exact path="/" element={<QuestionPage />} />
          <Route exact path="/login" element={<LoginPage />} />
          <Route exact path="/sgnup" element={<Signup />} />
          <Route exact path="/profile" element={< LabProfile/>} />
          <Route
            exact
            path="/otp"
            element={
              <Verify>
                <OtpVerify />
              </Verify>
            }
          />
          
          {/* <Route exact path="/account" element={<Profile/>}/>
          <Route exact path="/ask/:id" element={<QuestionPage/>}></Route>
          */}
          <Route exact path="/chemist_dashboard" element={<QuestionPage/>}></Route>
          <Route exact path="/chat_history" element={<ChatHistory/>}></Route>
          <Route exact path="/view_appointment" element={<ViewAppointments/>}></Route>
          <Route exact path="/view_lab_test" element={<ViewLabTests/>}></Route>
          <Route exact path="/view_reminder" element={<ViewReminders/>}></Route>
          <Route exact path="/view_reminder_report" element={<ViewReminderReport/>}></Route>
          <Route exact path="/medicine_chatbot" element={<MedicineChatbot/>}></Route>
          <Route exact path="/chat_summary" element={<PatientSummaryNote/>}></Route>
          <Route exact path="/write_prescription" element={<PrescriptionForm/>}></Route>
           <Route exact path="/bookings" element={<ChemistOrderDashboard/>}></Route>

          

        </Routes>
        </LanguageState>
      </BrowserRouter>
    </div>
  );
}

export default App;
